import { useState } from 'react';
import { Flex, Typography } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { MCheckbox, MoreButton } from '@Components/Base';
import { ReactComponent as CloseIcon } from '@Icons/additional/close-cross.svg';
import styles from './approval-bulk.module.css';

interface ApprovalBulkSectionProps {
  showActions: boolean;
  countSelectedTasks: number;
  actions: { key: string; label: JSX.Element }[];
  onShow: () => void;
  onSelectAll: (event: CheckboxChangeEvent) => void;
}

const ApprovalBulkSection: React.FC<ApprovalBulkSectionProps> = ({
  showActions,
  countSelectedTasks,
  actions,
  onSelectAll,
  onShow,
}) => {
  const [allText, setAlltext] = useState(false);

  return (
    <Flex align="center" style={{ width: '100%' }} gap={8}>
      {showActions ? (
        <MCheckbox
          onChange={(event) => {
            setAlltext(!allText);
            onSelectAll(event);
          }}
        />
      ) : (
        <Typography.Text className={styles.gradientText} onClick={onShow}>
          Select Requests for Bulk Actions
        </Typography.Text>
      )}

      {showActions && (
        <Flex justify="space-between" style={{ width: '100%' }}>
          <div style={{ textTransform: 'uppercase' }}>
            {allText ? 'All ' : null}
            <Typography.Text strong>
              {countSelectedTasks > 1
                ? `${countSelectedTasks} Requests `
                : `${countSelectedTasks} Request `}
            </Typography.Text>
            Selected
          </div>
          <Flex align="center" gap={10}>
            <Flex gap={10}>
              <Typography.Text className={styles.gradientText}>
                Actions
              </Typography.Text>
              <MoreButton
                className={styles.moreButton}
                title="Choose Action"
                actionItems={actions}
              />
            </Flex>
            <CloseIcon onClick={onShow} />
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};

export default ApprovalBulkSection;
